<template>
    <div :class="'relative w-full' + ' ' + wrapperCssClasses">
        <label
            v-if="label"
            :for="id"
            :class="'mb-2 block text-[14px] font-semibold' + ' ' + labelClasses"
        >
            <span v-html="label"></span>
        </label>

        <div class="relative flex items-center">
            <!--            <label-->
            <!--                v-if="label && labelPosition == 'inside' && modelValue"-->
            <!--                :for="id"-->
            <!--                :class="-->
            <!--                    'text-gray-1700 absolute left-4 top-2 z-20 text-[12px]' +-->
            <!--                    ' ' +-->
            <!--                    labelClasses-->
            <!--                "-->
            <!--            >-->
            <!--                <span v-html="label"></span>-->
            <!--            </label>-->

            <select
                :id="id"
                :name="name"
                :ref="id"
                :class="
                    themedCssClasses +
                    (disabled
                        ? ' cursor-not-allowed border-gray-400 opacity-50'
                        : '') +
                    ' ' +
                    ($page.props.errors[name]
                        ? ' !border-red-400 !bg-none'
                        : '') +
                    ' ' +
                    (modelValue ? '' : 'font-normal text-gray-500')
                "
                :value="modelValue"
                @input="updateInput"
                :disabled="disabled"
                :required="required"
            >
                <option v-if="allowNull" value="" class="">
                    {{ nullOption ?? label }}
                </option>

                <option v-for="option in options" :value="option.value">
                    {{ option.label }}
                </option>
            </select>

            <form-error-warning-triangle
                name="name"
                position-css="right-3  bottom-5"
            />
        </div>

        <div class="-mt-2 mb-3 text-[16px] text-gray-700" v-if="hint">
            {{ hint }}
        </div>

        <div class="absolute bottom-5 right-3" v-if="!$page.props.errors[name]">
            <svg
                width="12"
                height="6"
                viewBox="0 0 12 6"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M1.5 0.75L6 5.25L10.5 0.75"
                    stroke="#777777"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </div>

        <field-error :field-name="name" :message="$page.props.errors[name]" />
    </div>
</template>

<script>
import FieldError from "@/Components/FieldError";
import FormErrorWarningTriangle from "@/Components/FormErrorWarningTriangle";

export default {
    name: "FormSelect",
    components: {
        FieldError,
        FormErrorWarningTriangle,
    },
    props: {
        id: {
            type: String,
            default: "",
        },
        label: {
            type: String,
            default: "",
        },
        hint: {
            type: String,
            default: "",
        },
        name: {
            type: String,
            default: null,
        },
        placeholder: {
            type: String,
            default: null,
        },
        modelValue: {
            type: [String, Number],
            default: "",
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        required: {
            type: Boolean,
            default: false,
        },
        cssClasses: {
            type: String,
            default: "",
        },
        wrapperCssClasses: {
            type: String,
            default: "mb-4",
        },
        labelClasses: {
            type: String,
            default: "",
        },
        labelPosition: {
            type: String,
            default: "top",
        },
        options: {
            type: [Array, Object],
            default: null,
        },
        allowNull: {
            type: Boolean,
            default: false,
        },
        nullOption: {
            type: String,
            default: "",
        },
    },

    methods: {
        updateInput(event) {
            this.$emit("update:modelValue", event.target.value);
        },
    },
    mounted() {
        let defaultOption = this.options[0].value;

        if (!this.allowNull && this.modelValue == "") {
            this.$emit("update:modelValue", defaultOption);
        }
    },
    computed: {
        themedCssClasses() {
            let css = " appearance-none ";

            if (this.labelPosition == "inside") {
                css += "p-1 pl-3 pt-6 pr-12 ";
            } else {
                css += "p-[.6rem] pr-12 ";
            }

            css += " " + this.cssClasses;

            return css;
        },
    },
};
</script>
